import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {getUniversity} from '../api/university';
import {getUserApi} from '../api/users';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit {
  currentPage=""
  type=''
  constructor(private router:Router,private cd:ChangeDetectorRef) {
    router.events.subscribe(event => {

      if (event instanceof NavigationEnd ) {
        this.currentPage=event.url


      }
    });

  }



  navs=[
    {name:"إدارة السائقين",icon:"../../assets/images/icons/userIcon.svg",href:"/drivers",type:["1","2"]},
    {name:"إدارة  الحافلات",icon:"../../assets/images/icons/busIcon.svg",href:"/bus",type:["1","2"]},
    {name:"إدارة خطوط النقل",icon:"../../assets/images/icons/subscription.svg",href:"/trip-line",type:["1","2"]},
    // {name:"إدارة جدول الرحلات",icon:"../../assets/images/icons/file.svg",href:"/trips"},
    {name:"إدارة الرحلات المجدولة",icon:"../../assets/images/icons/schudle.svg",href:"/mange-travel",type:["1","2"]},
    {name:"تتبع الحافلات",icon:"../../assets/images/icons/busFront.svg",href:"/tracking",type:["1","2"]},
    // {name:"المحادثاث",icon:"../../assets/images/icons/chat.svg",href:"/test"},
    {name:"بث الأخبار",icon:"../../assets/images/icons/news.svg",href:"/all-news",type:["1","3"]},
    {name:"إدارة الاشتراكات",icon:"../../assets/images/icons/subscription.svg",href:"/subscription",type:["1","2"]},
    // {name:"التقارير",icon:"../../assets/images/icons/reports.svg",href:"/test",type:["1","2"]},
    {name:"الإعدادات",icon:"../../assets/images/icons/cog.svg",href:"/settings",type:["1"]},

  ]
name=''
uniName=''
uniLogo=''
adminPhoto=''
  ngOnInit() {
  this.name=localStorage.getItem('name')
  this.type=localStorage.getItem('type')
  this.uniName=localStorage.getItem('uniName')
  this.uniLogo=localStorage.getItem('uniLogo')
  this.adminPhoto=localStorage.getItem('admin_photo')


this.getUser()
    this.getUni()
  }


  async getUni(){
    let id=localStorage.getItem('uni')
    const result = await getUniversity(id);
    console.log(localStorage)
    console.log(result)
    if(result){
      this.uniName=result.data.data.ar_name
      this.uniLogo=result.data.data.logo
      localStorage.setItem('uniName',this.uniName)
      localStorage.setItem('uniLogo',this.uniLogo)
      this.cd.detectChanges()
    }

  }
  async getUser(){
    let id=localStorage.getItem('_id')
    const result = await getUserApi(id);
    if(result){
      this.name=result.data.data.name
      this.adminPhoto=result.data.data.profile_photo

      localStorage.setItem('name',this.name)
      localStorage.setItem('admin_photo',this.adminPhoto)

      this.cd.detectChanges()
    }

  }
  logout() {

    localStorage.clear()
    this.router.navigateByUrl('/login')

  }


}
